export const ADD_LEAD = "ADD_LEAD";
export const REQUEST_LEADS = "REQUEST_LEADS";
export const RECEIVE_LEADS = "RECEIVE_LEADS";